import type { FormBlockProps } from '@elfsight/widget-banner/widget';
import { FormBlock } from '@elfsight/widget-banner/widget';
import {
  useEmitAPIEvent,
  useRegisterAPIService
} from '@elfsight/widget-js-api';
import { API_FORM_SERVICE_NAME } from '../../constants';
import { usePopup } from '../../utils';

export function Form(formProps: FormBlockProps) {
  const {
    submitAction,
    onSubmitSuccessful = () => undefined,
    onSubmitMessageButtonClick = () => undefined
  } = formProps;
  const { close } = usePopup();
  const emitAPIEvent = useEmitAPIEvent();

  // наличие сервиса необходимо для работы события `submit`, вызываемого для этого сервиса
  useRegisterAPIService(API_FORM_SERVICE_NAME, () => ({}), []);

  const handleSubmitSuccessful = () => {
    if (submitAction === 'hide') {
      close();
    } else {
      emitAPIEvent('submit', [], API_FORM_SERVICE_NAME);
      onSubmitSuccessful(submitAction);
    }
  };

  const handleSubmitMessageButtonClick = () => {
    close();
    onSubmitMessageButtonClick();
  };

  return (
    <FormBlock
      {...formProps}
      onSubmitSuccessful={handleSubmitSuccessful}
      onSubmitMessageButtonClick={handleSubmitMessageButtonClick}
    />
  );
}
